export default "__VITE_ASSET__DXBYrtDi__"